import { IconButton } from '@mui/material';
import { CustomTooltip } from '../../../../../shared/helpers/functionalities';
import RefreshIcon from '@mui/icons-material/Refresh';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { fetchStockMetrics } from '../../../../../../../../redux/features/dashboard';
import InfoModal from '../../../../../shared/components/InfoModal';
import UpdateStockForm from './componentes/UpdateStockForm';

const StockTab = () => {
    const dispatch = useDispatch();
    const [isOpenUpdateStock, setIsOpenUpdateStock] = useState(false);

    const { stockMetrics } = useSelector((state) => {
        return state.dashboard.admin;
    });

    const getRatioClassName = (ratio) => {
        if (ratio < 97) {
            return 'danger-text';
        }
        if (ratio < 99) {
            return 'warning-text';
        }
        return 'success-text';
    };

    useEffect(() => {
        if (!stockMetrics) {
            dispatch(fetchStockMetrics());
        }
    }, []);

    return (
        <div className="w-100 d-flex flex-column align-items-center dashboard dashboard-stock-tab">
            <div className="w-100 mt-4 summary">
                <div className="w-100 d-flex align-items-center justify-content-between">
                    <h1>Stock publicado</h1>
                    <div>
                        <CustomTooltip
                            title="Editar piezas manualmente"
                            onClick={() => setIsOpenUpdateStock(true)}
                        >
                            <IconButton sx={{ color: '#215732' }}>
                                <EditIcon />
                            </IconButton>
                        </CustomTooltip>
                        <CustomTooltip
                            title={
                                'Última actualización: ' +
                                stockMetrics?.saved_cache_at
                            }
                            onClick={() => dispatch(fetchStockMetrics(true))}
                        >
                            <IconButton sx={{ color: '#215732' }}>
                                <RefreshIcon />
                            </IconButton>
                        </CustomTooltip>
                    </div>
                </div>

                <div className="w-100 mt-3">
                    <h2>
                        Piezas Recostock:{' '}
                        <span>{stockMetrics?.stock_recostock}</span>
                    </h2>

                    <div className="w-100 table-responsive">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>plataforma</th>
                                    <th className="text-center">
                                        aumento recostock
                                    </th>
                                    <th className="text-center">
                                        piezas en stock
                                    </th>
                                    <th className="text-center">
                                        diferencia recostock
                                    </th>
                                    <th className="text-center">ratio stock</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stockMetrics?.resumen.map((res) => {
                                    return (
                                        <tr key={'resumen-' + res.nombre}>
                                            <td>{res.nombre.toUpperCase()}</td>
                                            <td className="text-center">
                                                {res.aumento_plataforma ?? '-'}
                                            </td>
                                            <td className="text-center">
                                                {res.stock_plataforma}
                                            </td>
                                            <td className="text-center">
                                                {res.diferencia}
                                            </td>
                                            <td
                                                className={`text-center ${getRatioClassName(
                                                    res.nombre === 'Wallapop' ? 100 : res.ratio
                                                )}`}
                                            >
                                                {res.ratio}%
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isOpenUpdateStock && (
                <InfoModal
                    state={isOpenUpdateStock}
                    title={'Editar total piezas'}
                    content={
                        <UpdateStockForm
                            platforms={stockMetrics.resumen}
                            stockRecostock={stockMetrics.stock_recostock}
                            onClose={() => setIsOpenUpdateStock(false)}
                        />
                    }
                    width={'sm'}
                    onClose={() => setIsOpenUpdateStock(false)}
                ></InfoModal>
            )}
        </div>
    );
};

export default StockTab;
